// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import TicketsArea from './pages/TicketsArea';
import Splash from './pages/Splash';
import CrearPersonal from './pages/CrearPersonal'
import BuscarRut from './pages/BuscarRut';
import ListarPersonal from './pages/ListarPersonal';
import CargarProgramacion from './pages/CargarProgramacion';
import AlmuerzoDelDia from './pages/AlmuerzoDelDia';
import PronosticoMes from './pages/PronosticoMes';
import DashboardAlmuerzos from './pages/DashboardAlmuerzos';
import MantenedorMenuMes from './pages/MantenedorMenu';
import ReportesGanancia from './pages/ReporteGanancia';
import AdminLayout from './layouts/AdminLayout';
import DashboardAlmuerzosAdmin from './pages/DashboardAlmuerzosAdmin'
import AlmuerzosMes from './pages/AlmuerzosMes';

const App = () => {
  const isAuthenticated = localStorage.getItem('usuario') === 'Admin';

  return (
    <Router>
      <Routes >
        <Route path="/" element={<Login />} />
        <Route path="/almuerzoMes" element={<AlmuerzosMes />} />
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<DashboardAlmuerzos />} />
          <Route path="/tickets" element={isAuthenticated ? <Tickets /> : <Navigate to="/" />} />
          <Route path="/tickets-por-area" element={isAuthenticated ? <TicketsArea /> : <Navigate to="/" />} />
          <Route path="/buscar-rut" element={isAuthenticated ? <BuscarRut /> : <Navigate to="/" />} />
          <Route path="/splash" element={<Splash />} />
          <Route path="/crear-personal" element={isAuthenticated ? <CrearPersonal /> : <Navigate to="/" />} />
          <Route path="/listar-personal" element={isAuthenticated ? <ListarPersonal /> : <Navigate to="/" />} />
          <Route path="/cargar-programacion" element={isAuthenticated ? <CargarProgramacion /> : <Navigate to="/" />} />
          <Route path="/almuerzos" element={isAuthenticated ? <AlmuerzoDelDia /> : <Navigate to="/" />} />
          <Route path="/pronostico" element={isAuthenticated ? <PronosticoMes /> : <Navigate to="/" />} />
          <Route path="/menumes" element={isAuthenticated ? <MantenedorMenuMes /> : <Navigate to="/" />} />
          <Route path="/reporte" element={isAuthenticated ? <ReportesGanancia /> : <Navigate to="/" />} />

          <Route path="/dashboardAdmin" element={isAuthenticated ? <DashboardAlmuerzosAdmin /> : <Navigate to="/" />} />
        </Route>
      </Routes>
    </Router>
  );
};


//https://casinop2.sanjoseapps.cl/api/

export default App;
// src/App.js